import { memo } from 'react'
import { Box, Divider, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
    stickyHeader: {
        zIndex: 99
    },
    headerLabel: {
        padding: '8px 16px',
        fontSize: '14px',
        fontWeight: 500,
        textTransform: 'uppercase',
        background: theme.palette.background.paper
    }
}))

export type OverviewSectionHeaderProps = {
    title: string
    id?: string
    onClick?: () => void
    sticky?: boolean
}

const OverviewSectionHeader = ({ title, id, onClick, sticky = false }: OverviewSectionHeaderProps) => {
    const { classes, cx } = useStyles()

    return (
        <Box onClick={onClick} className={sticky ? cx(classes.stickyHeader, 'sticky') : undefined}>
            <Divider />
            <Typography id={id} className={classes.headerLabel}>
                {title}
            </Typography>
        </Box>
    )
}

export default memo(OverviewSectionHeader)
